import request from '@/utils/request'
import Vue from 'vue'

//历年茶叶种植面积
export function getTeaPlantingAreaOverTheYear(data) {
  return request({
    method: 'POST',
    url: Vue.prototype.dataCenterUrl + '/tea-planting-area/selectListByPage',
    data
  })
}

//历年茶叶加工产量
export function getTeaPlantingProcessingYieldOverTheYear(params) {
  return request({
      method: 'POST',
      url: Vue.prototype.dataCenterUrl + '/tea-planting-processing-yield/getTeaPlantingProcessingYieldOverTheYearList',
      params
  })
}
//历年茶叶加工产值
export function teaProductionEcharts(params) {
  return request({
      method: 'POST',
      url: Vue.prototype.dataCenterUrl + '/tea-planting-Output/getTeaPlantingOutputOverTheYearList',
      params
  })
}
//历年茶叶种植面积
export function teaSeedingPlantingArea(data) {
  return request({
      method: 'POST',
      url: Vue.prototype.dataCenterUrl + '/tea-seeding-planting-area/selectListByPage',
      data
  })
}

